import Box from "ds/components/Box";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";

import { CellComponentProps } from "../types";

type ApiKeyGroupsMappingListItemDescriptionCellProps = CellComponentProps;

const ApiKeyGroupMappingListItemDescriptionCell = ({
  group,
}: ApiKeyGroupsMappingListItemDescriptionCellProps) => {
  if (!group.description) {
    return null;
  }

  return (
    <Box direction="row" align="start">
      <ListEntitiesItemDescriptionMultipleLines
        lines={1}
        hasChevronLink
        description={group.description}
      />
    </Box>
  );
};

export default ApiKeyGroupMappingListItemDescriptionCell;
